export const TEST_DOMAIN_STATUS_ENDPOINT = '/config/test-domain';

export interface TestDomainStatus {
  isTestDomain: boolean;
  mainDomainUrl: string;
}

interface ApiResponse<T> {
  success?: boolean;
  data?: T;
  message?: string;
}

export const fetchTestDomainStatus = async (hostname: string): Promise<TestDomainStatus> => {
  const query = new URLSearchParams({ hostname });
  const response = await fetch(`${TEST_DOMAIN_STATUS_ENDPOINT}?${query.toString()}`, {
    method: 'GET',
    credentials: 'include',
    cache: 'no-store',
  });
  if (!response.ok) {
    throw new Error(`Failed to fetch test-domain status: ${response.status}`);
  }

  const result = (await response.json()) as ApiResponse<TestDomainStatus>;
  if (result.success !== true || typeof result.data?.isTestDomain !== 'boolean' || !result.data.mainDomainUrl) {
    throw new Error(result.message || 'Invalid test-domain status response');
  }
  return result.data;
};
